define('controllers/wishlist',['require','controllers/base/controller','views/pages/wishlist/index','models/pages/wishlist/index'],function(require) {
    'use strict';

    var Controller = require('controllers/base/controller'),
        WishlistPageView = require('views/pages/wishlist/index'),
        WishlistPageModel = require('models/pages/wishlist/index');

    var WishlistController = Controller.extend({
        show: function(params, route, opts) {

            var model = new WishlistPageModel({
                page: params.page,
                type: params.type
            });

            var pageView = new WishlistPageView({model: model});

            this.view = pageView;
        }
    });

    return WishlistController;
});

